module.exports = __webpack_public_path__ + "img/Vive-Real-Estate-Team-300x195.9f7585ec.jpeg";